module.exports = __webpack_public_path__ + "img/BLITZ POSITANO-366-retro.80a669dc.jpg";